export default {
  methods: {
    validateState(name) {
      let array = name.split('.');
      let formElement;
      array.forEach(element => {
        if (formElement) {
          formElement = formElement[element]
          return;
        }
        formElement = this.$v.form[element];
      })
      const {$dirty, $error} = formElement;
      return $dirty ? !$error : null;
    },
  }
}